export function initializeDropdownHandler(mobileMenu) {
    if (! mobileMenu) {
        return;
    }

    mobileMenu.querySelectorAll('nav > ul > li > a').forEach((link) => {
        link.addEventListener('click', function () {
            const currentSubmenu = this.parentNode.querySelector('.submenu');

            this.closest('.mob_menu').querySelectorAll('.submenu').forEach((submenu) => {
                if (submenu !== currentSubmenu) {
                    submenu.style.maxHeight = 0;
                    setTimeout(() => {
                        submenu.classList.remove('open');
                    }, 500);
                }
            });

            if (! currentSubmenu) {
                return;
            }

            const chevron = this.querySelector('.bi-chevron-down');

            if (currentSubmenu.classList.contains('open')) {
                currentSubmenu.style.maxHeight = 0;
                setTimeout(() => {
                    currentSubmenu.classList.remove('open');
                }, 500);
                if (chevron) {
                    chevron.style.transform = 'rotate(0deg)';
                }

                return;
            }

            currentSubmenu.classList.add('open');
            currentSubmenu.style.maxHeight = `${currentSubmenu.scrollHeight}px`;
            if (chevron) {
                chevron.style.transform = 'rotate(180deg)';
            }
        });
    });
}

if (typeof document !== 'undefined') {
    initializeDropdownHandler(document.querySelector('.mob_menu'));
}
